<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'followUps.modal.setNotesTitle' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="close()"></i>
  </div>
  <div class="modal-body">
    <textarea
      class="form-control w-100"
      [formControl]="notesFormControl"
    ></textarea>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      (click)="submit()"
      [disabled]="notesFormControl.invalid || loading()"
    >
      @if (loading()) {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      } @else {
        {{ 'followUps.modal.buttons.setNotes' | translate }}
      }
    </button>
  </div>
</div>
